import { Directive, inject, OnInit } from '@angular/core';

import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { takeUntil } from 'rxjs';

import { CollectionsService } from '../data/services/collections.service';
import { AbstractComponent } from './abstract.component';

@Directive()
export abstract class AbstractLocalizedComponent extends AbstractComponent implements OnInit {
  protected collectionsService: CollectionsService;
  protected localizeRouterService: LocalizeRouterService;

  constructor() {
    super();
    this.collectionsService = inject(CollectionsService);
    this.localizeRouterService = inject(LocalizeRouterService);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.loadData(this.localizeRouterService.parser.currentLang);
    this.localizeRouterService.routerEvents.pipe(takeUntil(this.unsubscribeAll$)).subscribe(locale => this.loadData(locale));
  }

  protected abstract loadData(locale: string): void;
}
